// armar el contexto de person para el hotel
import React, { useState, useContext } from "react";
import * as Yup from "yup";
import { HotelContext } from "./hotel";
import { usePersistentState } from '../hooks/usePersistentState';

const PersonContext = React.createContext({ data: {} })
const publicBookablePersonSchema = Yup.object().shape({
    fullname: Yup.string()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
    // .required(() => getTranslation('yup.required')),
    phone: Yup.string()
        .required("yup.required"),
    email: Yup.string()
        .email("yup.email-invalid-format")
        .required("yup.required")
});
function PersonProvider({ children }) {
    const { data: hotel } = useContext(HotelContext);

    const [data, setData, setPartialData] = usePersistentState(`person`, null, 72000)


    const logoutPerson = () => {
        localStorage.removeItem(`ViCo::token-${hotel?.id}-person`);
        setData({});
    }
    const setUpdateData = (newData) => {
        setPartialData(newData);
    }

    const value = {
        data,
        setData,
        setUpdateData,
        logoutPerson
    }
    return <PersonContext.Provider value={value}>{children}</PersonContext.Provider>;
};

export const usePerson = () => {
    return useContext(PersonContext);
};

export { PersonProvider, PersonContext, publicBookablePersonSchema };